$(function () {

	// Set variables

	var body = $('body');
	var header = $('.site-header');
	var footer = $('.site-footer');
	var tablet_breakpoint = 1024;
	var mobile_breakpoint = 622;

	function getParameterByName(name) {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		var regexS = "[\\?&]" + name + "=([^&#]*)";
		var regex = new RegExp(regexS);
		var results = regex.exec(window.location.href);
		if (results == null)
			return "";
		else
			return decodeURIComponent(results[1].replace(/\+/g, " "));
	}

	// Scroll up header

	var lastScrollTop = 40;
	$(window).scroll(function () {

		if ($(window).scrollTop() >= 60) {

			var st = $(this).scrollTop();

			if (st > lastScrollTop) {
				body.addClass('scrolled');
			} else {
				body.removeClass('scrolled');
			}

			lastScrollTop = st;

		}

	});

	$(document).on('click', '.ani-scroll', function (e) {
		e.preventDefault();
		var goToSection = $(this).attr('href');

		if ($(goToSection).length) {

			if ($(window).width() > 1023) {
				$('html, body').animate({
					scrollTop: $(goToSection).offset().top - 100
				}, 1000);
			} else {
				$('html, body').animate({
					scrollTop: $(goToSection).offset().top - 30
				}, 1000);
			}

			if ($(this).hasClass('reviews') && $('.info-tabs .product-reviews').length) {
				$('.info-tabs .product-reviews').addClass('active');
			}
		}

	});

	function dynamicShowBanner(ele) {
		var ele = $('' + ele + '');
		var ele_height = ele.outerHeight() - 1;
		//set document css variable (announcement bar height)
		document.documentElement.style.setProperty('--announcement-bar-height', ele_height + 'px');


		// if there is a sub nav on the page, this top offset along with its spacer needs amending too

		const subNav = $('.sub-nav')
		if (subNav.length) {
			const subNavHeight = subNav.outerHeight() - 1;
			console.log("subNavHeight", subNavHeight)
			if (subNav.closest('.collection-template').length) {
				$('.sub-nav-spacer').css('padding-top', subNavHeight + 'px');
			} else {
				$('.sub-nav-spacer').css('padding-bottom', ele_height + 'px');
			}
			//$('.sub-nav').css('top', current_hs + ele_height + 'px');

		}
	}

	if ($('.announcement-bar').length) {
		dynamicShowBanner('.announcement-bar');
	}

	/* Header toggle/classes logic */
	$(document).on('click', '.j-mob-menu-toggle', function (e) {
		e.preventDefault();
		const header = $(this).closest('.site-header');
		header.toggleClass('open');

		if ($('.announcement-bar').length) {
			header.toggleClass('flush-top');

			if ($('.sub-nav').length) {
				$('.sub-nav').toggleClass('flush-sub-nav');
				$('.sub-nav-spacer').toggleClass('pb-0');
			}
		}

		// Auto expand the first dropdown on mobile, if none of them is expanded
		const isHeaderActive = header.hasClass("open");
		if (isHeaderActive) {
			const dropdowns = header.find(".has-dropdown");
			const activeDropdowns = dropdowns.filter('.active');
			
			if (!activeDropdowns.length) {
				dropdowns.filter('[data-auto-expand]').first().addClass("active");
			}
		}
		// this was adding active to dropdown on mobile - keeping them open
		// $(this).closest('.site-header').find('.menu-wrapper .left .has-dropdown .sub-menu .active-default').addClass('active');
		// This keeps sub menu open
		header.find('.active-default').addClass('active');
		// console.log("NEED TO ADD ACTIVE TO THIS ELEMENT: ", $(this).closest('.site-header').find('.active-default'))

		body.toggleClass('locked');
	});

	// Mobile only breakpoint 

	// Handles toggle of the top level menu dropdowns for the HEADER
	$(document).on('click', '.has-dropdown .top-level-link', function (e) {
		// does not apply on desktop
		if ($(window).width() >= tablet_breakpoint) return;
		e.preventDefault();


		if ($(this).closest('.has-dropdown').hasClass('active')) {

			//Add active class to the menu that has to be open by default 
			header.find('.active-default').addClass("active")

			header.find('.has-dropdown .dropdown .sub-menu:not(.active-default)').removeClass('active');
			// header.find('.has-dropdown').removeClass('active');
			$(this).closest('.has-dropdown').removeClass('active');

		} else {

			header.find('.has-dropdown .dropdown .sub-menu:not(.active-default)').removeClass('active');
			// header.find('.has-dropdown').removeClass('active');
			$(this).closest('.has-dropdown').addClass('active');

		}

	});

	// Handles toggle of the sub menu dropdowns for the HEADER & FOOTER
	$(document).on('click', '.has-dropdown .dropdown .sub-menu .j-drill-toggle, .site-footer .sub-menu .j-drill-toggle', function (e) {
		// does not apply on desktop
		if ($(window).width() >= tablet_breakpoint) return;

		e.preventDefault();

		// 		if($(this).closest('.site-footer').length > 0) {
		// 			$('.site-footer').find('.sub-menu').removeClass('active');
		// 		} else {
		// 			header.find('.has-dropdown .dropdown .sub-menu').removeClass('active');
		// 		}

		// 		if( !$(this).closest('.sub-menu').hasClass('active') ) {
		// $(this).closest('.sub-menu').addClass('active');
		// 		} else {
		// $(this).closest('.sub-menu').removeClass('active');
		// 		}



		if ($(this).closest('.sub-menu').hasClass('active')) {

			if ($(this).closest('.site-footer').length > 0) {
				// if the button clicked was inside of the footer, then close the footer ones
				$('.site-footer').find('.sub-menu').removeClass('active');
			} else {
				// otherwise close the header ones
				header.find('.has-dropdown .dropdown .sub-menu').removeClass('active');
			}


		} else {

			if ($(this).closest('.site-footer').length > 0) {
				// if the button clicked was inside of the footer, then close the footer ones
				$('.site-footer').find('.sub-menu').removeClass('active');
			} else {
				// otherwise close the header ones
				header.find('.has-dropdown .dropdown .sub-menu').removeClass('active');
			}

			// header.find('.has-dropdown .dropdown .sub-menu').removeClass('active');
			$(this).closest('.sub-menu').addClass('active');
		}



	});

	/* End */

	/* Site header, top-level active link handler (for when sublinks are active) */
	if ($('.site-header').length) {
		$('.site-header .menu-wrapper .left li.has-dropdown').each(function (index, el) {
			// var _isActive = false;
			if ($(this).find('.sub-menu-link.active').length > 0) {
				$(this).find('a.top-level-link').addClass('active');
			}
		});
	}
	/* End*/

	/* Featured Blogs Shuffle.js */

	var shuffle;
	var element;
	var sizer;
	var shuffleInstance;

	if ($('.featured-blog-listing').length) {

		Shuffle = window.Shuffle;
		// var element = document.querySelector('.featured-blog-listing .shuffle-container');
		element = $('.featured-blog-listing .shuffle-container');
		sizer = $('.featured-blog-listing .sizer');

		shuffleInstance = new Shuffle(element, {
			itemSelector: '.j-shuffle-item',
			sizer: sizer,
			speed: 1000,
			useTransforms: false
		});

	}
	/* end */

	/* Featured collection panel logic */

	if ($('.featured-collection-listing').length) {

		$(document).on('click', '.featured-collection-listing .j-toggle-col-panel', function (e) {
			e.preventDefault();
			/* Act on the event */

			var target_panel_id = '#' + $(this).data('open-panel');

			if (!$(this).hasClass('active')) {

				var primary_colour = $(this).css('border-color');

				$('.featured-collection-listing .j-toggle-col-panel').removeClass('active');

				$('.featured-collection-listing .j-toggle-col-panel').css({
					'background-color': 'transparent'
				});

				$(this).addClass('active');

				$(this).css({
					'background-color': primary_colour
				});

			}
			$('.featured-collection-listing .panel-item').addClass('hidden');
			$('.featured-collection-listing').find(target_panel_id).removeClass('hidden');
		});

		$('.featured-collection-listing .j-toggle-col-panel').first().trigger('click');

	}
	/* end */

	/* FAQ listing */

	// Custom selector to use insensitive casing 

	jQuery.expr[':'].containsIgnoreCase = function (a, i, m) {
		return jQuery(a).text().toUpperCase()
			.indexOf(m[3].toUpperCase()) >= 0;
	};

	if ($('.faq-template').length) {
		$(document).on('click', '.j-acc-title-toggle', function (e) {
			e.preventDefault();

			if (!$(this).closest('.item').hasClass('active')) {
				$(this).closest('.item').addClass('active');
			} else {
				$(this).closest('.item').removeClass('active');
			}
		});

		$(document).on('submit', '#faq-search-form', function (e) {
			e.preventDefault();
			var search = $('#search-faqs').val();
			var container = $('.faq-blocks .item .answer p:containsIgnoreCase("' + search + '"),.faq-blocks .item .accordion-title:containsIgnoreCase("' + search + '")');

			console.log('Search term: ' + search);

			$('.faq-blocks .item').removeClass('active');

			if (search.length >= 1) {
				if (container.length >= 1) {

					var goToSection = container.first();

					$('html, body').animate({
						scrollTop: $(goToSection).offset().top - 200
					}, 1000);

					container.closest('.item').addClass('active');

					$('.faq-search-wrap .error').fadeOut();

				} else {

					$('.faq-search-wrap .error').text('Sorry, that search term hasn\'t returned any results. Please try again.').fadeIn();

				}
			} else {

				$('.faq-search-wrap .error').text('Please enter a search term and try again.').fadeIn();

			}

		});

	}
	/* end */

	/* CookieYes — reopen consent banner from policy page */
	$(document).on('click', '.j-cookie-pref-settings', function (e) {
		e.preventDefault();
		var revisitBtn = document.querySelector('.cky-btn-revisit');
		if (revisitBtn) revisitBtn.click();
	});
	/* end */

	// Style images on article page

	$('.j-wsiwig-imgs img').each(function () {

		if ($(this).attr('alt') == 'half') {

			$(this).addClass('img-half');
			$(this).parent().addClass('image-wrapper');

		}

		if ($(this).attr('alt') == 'full') {

			$(this).addClass('img-full');
			$(this).parent().addClass('image-wrapper');

		}

	});

	/* Product detail accordion */
	if ($('.info-tabs').length) {
		$(document).on('click', '.j-acc-title-toggle', function (e) {
			e.preventDefault();

			if (!$(this).closest('.tab').hasClass('active')) {
				$(this).closest('.tab').addClass('active');
			} else {
				$(this).closest('.tab').removeClass('active');
			}
		});
	}
	/* end */


	/* Start of product card handlers/logic and overall cart functions */

	/* updates quantity without adding to cart, lets the button click do that should the user want to */
	if ($('.purchase-data').length) {
		console.log(document.querySelectorAll('[data-quantity-selector] span'));
		$(document).on('click', '[data-quantity-selector] span', function (e) {
			e.preventDefault();
			var q_input = $(this).closest('[data-quantity-selector]').find('input');
			var p_btn = $(this).closest('.purchase-data').find('.btn-wrap .j-product-to-cart');

			if ($(this).hasClass('minus')) {

				if (q_input.val() < 2) {
					console.log('smaller than 0');
				} else {
					var counter = parseInt(q_input.val());
					counter--;
					q_input.val(counter);
					q_input.attr({
						value: counter
					});

					p_btn.data('qty', counter);
					p_btn.attr({
						'data-qty': counter
					});
				}
			}

			if ($(this).hasClass('plus')) {

				var counter = parseInt(q_input.val());
				counter++;
				q_input.val(counter);
				q_input.attr({
					value: counter
				});

				p_btn.data('qty', counter);
				p_btn.attr({
					'data-qty': counter
				});
			}

		});

		$(document).on('input', '.quantity-selector .j-quantity-update', function (e) {
			var q_input = $(this)
			var p_btn = $(this).closest('.purchase-data').find('.btn-wrap .j-product-to-cart');

			var counter = parseInt(q_input.val());
			if(counter < 1) {
				counter = 1;
				q_input.val(counter);
				q_input.attr({
					value: counter
				});
			}

			console.log(counter);

			p_btn.data('qty', counter);
			p_btn.attr({
				'data-qty': counter
			});
		});
	}
	/* end */

	// updates cart text to the current amount of items in the cart (on load)
	$('.j-toggle-cart .cart-text').text(window.cart.item_count);

	function checkExistsInCart(itemID) {
		var matchFound = false;
		var quantity = 0;

		for (var i = cart.items.length - 1; i >= 0; i--) {
			if (cart.items[i].id == itemID) {
				matchFound = true;
				quantity = cart.items[i].quantity;
			}
		}
		return { exists: matchFound, quantity: quantity };
	}

	function loadProductDetails() {

		$('.product-card').each(function (index, el) {
			syncQuantity($(this));
		});

	}

	function syncQuantity(_this) {
		var result = checkExistsInCart(_this.data('pid'));
		if (result.exists) {
			_this.find('.overlay-btn-item').addClass('has-in-basket');
			_this.find('.overlay-btn-item .quantity-wrap .q-info input').val(result.quantity);
			_this.find('.overlay-btn-item .quantity-wrap .q-info input').attr('value', result.quantity);
			_this.find('.overlay-btn-item .quantity-wrap .q-info span').text(result.quantity);
		} else {
			_this.find('.overlay-btn-item').removeClass('has-in-basket');
			_this.find('.overlay-btn-item .quantity-wrap .q-info input').val(0);
			_this.find('.overlay-btn-item .quantity-wrap .q-info input').attr('value', 0);
			_this.find('.overlay-btn-item .quantity-wrap .q-info span').text(0);
		}
	}

	if ($('.product-card').length) {
		loadProductDetails();
	}

	// qty button listeners logic

	$(document).on('click', '.quantity-wrap .q-selector', function (e) {
		e.preventDefault();

		var qty_input = $(this).closest('.quantity-wrap').find('.q-info input');
		var qty_text = $(this).closest('.quantity-wrap').find('.q-info span');
		var itemID = $(this).closest('.quantity-wrap').data('pid');
		var counter = parseInt(qty_input.val());

		if ($(this).hasClass('minus')) {

			if (qty_input.val() < 2) {
				console.log('Tried to decrement when qty was 1');

				// remove from cart
				// update the val in qty input
				// show the add to cart button again (aka remove has-in-basket class)
				CartJS.updateItemById(itemID, 0);
				qty_input.val(0);
				qty_input.attr('value', 0);
				qty_text.text("0");
				$(this).closest('.overlay-btn-item').removeClass('has-in-basket');

			} else {

				// var counter = parseInt(qty_input.val());
				counter--;
				qty_input.val(counter);
				qty_input.attr('value', counter);
				qty_text.text(counter);
				CartJS.updateItemById(itemID, counter);

			}
		}

		if ($(this).hasClass('plus')) {

			// var counter = parseInt(qty_input.val());
			counter++;
			qty_input.val(counter);
			qty_input.attr('value', counter);
			qty_text.text(counter);
			CartJS.updateItemById(itemID, counter);
			$(this).closest('.overlay-btn-item').addClass('has-in-basket');

		}

	});

	Array.from(document.querySelectorAll(".vue-product-options")).forEach(function (el) {
		const productId = el.dataset.productId;
		const form = el.closest(`form[data-product-id="${productId}"]`);
		const addToCartButton = form?.querySelector(".j-product-to-cart");

		if (!addToCartButton) return;

		el.addEventListener("change", function (e) {
			const selectedVariantId = form.querySelector("[data-selected-variant-id]")?.value;
			$(addToCartButton).data('vid', selectedVariantId);
		});
	});

	// Simple add to cart function

	function addToCart(_this) {

		var variantID = _this.data('vid');
		var variantQty = _this.data('qty');
		var tags = _this.data('tags');
		var properties = {};

		console.log(variantID);
		console.log(variantQty);
		console.log(properties);

		if (_this.closest('.product-card').length) {
			_this.closest('.overlay-btn-item').addClass('has-in-basket');
			// syncQuantity(_this.closest('.product-card'));
			_this.closest('.overlay-btn-item').find('.quantity-wrap .q-info input').val(1);
			_this.closest('.overlay-btn-item').find('.quantity-wrap .q-info input').attr('value', 1);
			_this.closest('.overlay-btn-item').find('.quantity-wrap .q-info span').text('1');
		}

		CartJS.addItem(variantID, variantQty, properties, {
			"success": function (data, textStatus, jqXHR) {

				console.log('added to basket');
				// _this.html('<i class="far fa-thumbs-up"></i> Added!').addClass('pale-blue');

			},
			"error": function (jqXHR, textStatus, errorThrown) {

				console.log('cart js Error');
				// _this.html('An error occurred');

			}
		});

	}

	/* Mailchimp */

	function sanitizeMCreponse(resp) {
		var msg = "";

		var index = -1;
		try {
			var parts = resp.msg.split(' - ', 2);
			if (parts[1] === undefined) {
				msg = resp.msg;
			} else {
				var i = parseInt(parts[0], 10);
				if (i.toString() === parts[0]) {
					index = parts[0];
					msg = parts[1];
				} else {
					index = -1;
					msg = resp.msg;
				}
			}
		}
		catch (e) {
			index = -1;
			msg = resp.msg;
		}
		return msg;
	}

	function initMcAjaxForm(mc_url, ele) {
		// console.log("ELEMENT",ele);
		var form = ele.find('.mc-newsletter-form');
		// console.log("FORM", form);

		form.ajaxChimp({
			url: mc_url,
			callback: function (resp) {

				// resets all info messages from all mc forms
				$('.info-messages .errors,.info-messages .success').removeClass('show');

				if (resp.result === "success") {

					setTimeout(function () {
						ele.find('.info-messages .success').addClass('show');
						ele.find('input[type="text"], input[type="email"]').val("");
					}, 500);

				} else {
					var display_msg = "Error - Invalid email address"

					var msg = sanitizeMCreponse(resp);

					if (msg.includes("is already subscribed")) {
						display_msg = "You've already subscribed";
					}

					setTimeout(function () {
						ele.find('.info-messages .errors').text(display_msg).addClass('show');
					}, 500);
				}
			}
		});

	}

	//contact form logic
	if ($(".template-contact-us")) {
		// let klaviyoLoaded = false; 
		// waitUntilContentIsGenerated();

		// async function waitUntilContentIsGenerated() {
		// 	return new Promise(resolve => {
		// 	  //  Wait for the content to be inserted into the DOM
		// 	  const observer = new MutationObserver(() => {
		// 		console.log("Attaching observer ");

		// 		// Once the content is inserted, resolve the promise
		// 		resolve();
		// 		klaviyoLoaded = true;
		// 		console.log($(".contact-hidden-form-klaviyo .klaviyo-form-V9BL6F form"))
		// 		// Disconnect the observer to stop observing
		// 		observer.disconnect();
		// 	  });
		// 	  // Start observing the parent element that contains the dynamically generated content
		// 	  observer.observe(document.querySelector('.contact-hidden-form-klaviyo .klaviyo-form-V9BL6F'), { childList: true });
		// 	});
		//   } 
		//   const klaviyoEmail = $(".contact-hidden-form-klaviyo .klaviyo-form-V9BL6F form input[type='email']:not([disabled])");

		// async function handleAsyncSubmit(contactEmail){
		// 	// Use 'await' here to wait for the dynamically generated content to be inserted
		// 	// await waitUntilContentIsGenerated();
		// 	console.log("form generated , changing email into :", contactEmail);
		// 	const klaviyoForm = $(".contact-hidden-form-klaviyo .klaviyo-form-V9BL6F form");
		// 	const klaviyoFormButton= $(".contact-hidden-form-klaviyo .klaviyo-form-V9BL6F form button");

		// 	klaviyoEmail.attr("aria-invalid","false");
		// 	klaviyoEmail.val(contactEmail);

		// 	// klaviyoFormButton.click();
		// 	// klaviyoForm.submit();
		// 	console.log("KLAV EMAIL:", klaviyoEmail);
		// 	console.log("KLAV EMAIL value:", klaviyoEmail.val());
		// 	console.log("klaviyo form: ", klaviyoForm);
		// }

		$(window).on("load", function () {
			KlaviyoSubscribe.attachToForms('#email_signup_Uk3Mpj', {
				hide_form_on_success: true,
				extra_properties: {
					$source: '$embed',
					$method_type: "Klaviyo Form",
					$method_id: 'embed',
					$consent_version: 'Embed default text'
				}
			});
			console.log("loaded");
		});

		//form change logic
		const reasonSelect = $("#reason");
		$('.trigger-buttons').hide();
		reasonSelect.on("change", function (e) {
			const reason = reasonSelect.find("option:selected").data("handle");
			if (!$(this).find("option:selected").is(":disabled")) {
				$('.trigger-buttons').show();
			}

			// Hide all the form-builder-component divs and disable all the fields
			$(".form-builder-component").addClass("hidden");
			$(".form-builder-component :input").attr("disabled", true);

			// Show the div with the selected category and remove disabled on fields
			$(`.form-builder-component[data-category="${reason}"]`).removeClass("hidden");
			$(`.form-builder-component[data-category="${reason}"] :input`).removeAttr("disabled");

		})

		//Need to check if url contains reason parameter to show the form again as it errored out
		const urlParams = new URLSearchParams(window.location.search);
		const reasonParam = urlParams.get("contact[reason]");
		if (reasonParam) {
			console.log("found reason parameter")
			reasonSelect.val(reasonParam);
			reasonSelect.trigger("change");
			$('html,body').animate({
				scrollTop: $(".info-messages").offset().top
			}, 'slow');

		}

		//submission logic
		const contactForm = $('#contact_form button');
		var contactEmailField = $("#contact_form input[type='email']");

		contactForm.on("click", function (event) {
			event.preventDefault();
			//reseet error fields
			$(".error-field").hide();
			//Email validation
			if (!$("#contact_form input[type=email]:not([disabled])").get(0).checkValidity()) {
				$("#contact_form input[type=email]:not([disabled]) + .error-field").show();
				return false;
			}
			if (!$("#contact_form input[type=checkbox]:not([disabled])#accept").get(0).checkValidity()) {
				$(".trigger-buttons .error-field").show();
				return false;
			}
			console.log($("#contact_form input[type=email]:not([disabled])").get(0).checkValidity());

			console.log("active email field", $("#contact_form input[type=email]:not([disabled])"))
			// contactEmailField = $("#contact_form input[type='email']:not([disabled])");
			const subscribeCheckbox = $("#contact_form [data-klaviyo-sub-checkbox]")

			if (subscribeCheckbox.is(":checked")) {
				const klaviyoForm = $("#email_signup_Uk3Mpj")
				console.log("The subscribe flow HAS BEEN STARTED");
				// const hiddenEmail = $("#k_id_email");
				// hiddenEmail.val(contactEmailField.val());
				// console.log("KLAV VAL", hiddenEmail.val());
				klaviyoForm.trigger("submit");
			}

			$(this).parents('#contact_form').trigger("submit");

		})

		contactEmailField.on('input', function () {
			const hiddenEmail = $("#k_id_email");
			hiddenEmail.val($(this).val());
			// klaviyoEmail.val(contactEmailField.val());
		});



	}

	// init mc ajax form for the footer
	initMcAjaxForm('https://dragonflytea.us8.list-manage.com/subscribe/post?u=6194950d1adc46301ff813b9a&id=f7e05aeb72', $('.site-footer'));

	// init mc ajax form for the modal newsletter
	initMcAjaxForm('https://dragonflytea.us8.list-manage.com/subscribe/post?u=6194950d1adc46301ff813b9a&id=f7e05aeb72', $('.newsletter-modal'));

	if ($('.custom-form-wrapper .mc-form-wrapper')) {
		initMcAjaxForm('https://dragonflytea.us8.list-manage.com/subscribe/post?u=6194950d1adc46301ff813b9a&amp;id=b5d40403b9', $('.custom-form-wrapper'));
	}

	if ($('pdp-popup.form-popup')) {
		initMcAjaxForm('https://dragonflytea.us8.list-manage.com/subscribe/post?u=6194950d1adc46301ff813b9a&id=f7e05aeb72', $('.pdp-popup.form-popup'));
	}

	// toggle optin state form button

	$(document).on('click', '.j-trigger-consent', function (e) {

		if (!$(this).find('input.consent-checkbox').is(':checked')) {
			// $(this).closest('form').find('.j-optin-btn').addClass('disabled').attr({disabled: 'true'});
			$(this).closest('form').find('.j-optin-btn').prop("disabled", true).addClass('disabled');
		} else {
			// $(this).closest('form').find('.j-optin-btn').removeClass('disabled').attr({disabled: 'false'});
			$(this).closest('form').find('.j-optin-btn').prop("disabled", false).removeClass('disabled');
			// $('.j-mc-optin-btn').prop( "disabled", false ).removeClass('disabled');
		}

	});

	/* End Mailchimp */

	$(document).on('click', '.j-show-loading ', function (e) {
		$(this).closest('.btn-wrap').addClass('loading');
	});

	$(document).on('click', '.j-toggle-cart', function (e) {
		e.preventDefault();

		if ($('.popout-cart').hasClass('active')) {
			$('.popout-cart').removeClass('active');
			$('.modal-overlay.cart-modal-overlay').removeClass('active');
			$('body').removeClass('locked');
		} else {
			$('.popout-cart').addClass('active');
			$('.modal-overlay.cart-modal-overlay').addClass('active');
			$('body').addClass('locked');
		}

		// $('.popout-cart').toggleClass('active');
		// $('.modal-overlay.cart-modal-overlay').toggleClass('active');
	});

	$(document).on('click', '.j-product-to-cart', function (e) {

		e.preventDefault();
		var _this = $(this);
		addToCart(_this);
		$('.site-header .j-toggle-cart').first().trigger('click');

	});

	$(document).on('cart.requestComplete', function (event, cart) {

		cartRequestComplete();

	});

	function cartRequestComplete() {

		console.log('cartRequestComplete');

		jQuery.getJSON('/cart.js', function (cart) {

			var cart_text = $('.j-toggle-cart .cart-text');
			cart_text.text(cart.item_count);
			jQuery(document).trigger('cart.afterManualUpdate', [cart]);
		});

	}

	// Close newsletter modal

	$(document).on('click', '.j-close-newsletter-modal', function (e) {

		e.preventDefault();

		$('.nl-modal-overlay').removeClass('active');
		// $(this).closest('.newsletter-modal').removeClass('active');
		$('.newsletter-modal').removeClass('active');
		Cookies.set('newsletter_modal', 'true', { expires: 365 });

	});


	// Set cookie for cookie policy modal
	/*
	var newsletter_modal = Cookies.get('newsletter_modal');

	if(newsletter_modal == undefined) {

		console.log('newsletter_modal undefined');
		setTimeout(function(){
			$('.newsletter-modal,.nl-modal-overlay').addClass('active');
		}, 3000);

	}
	*/

	/* Dynamically applies shadows on sub navs that can be scrolled */
	function applyShadow(prop) {

		if (prop.scrollLeft() < 5) {
			prop.closest('.sub-nav').removeClass('l-shadow');
		} else {
			prop.closest('.sub-nav').addClass('l-shadow');
		}

		var endval = prop[0].scrollWidth - prop.innerWidth();

		if (prop.scrollLeft() > (endval - 10)) {
			prop.closest('.sub-nav').removeClass('r-shadow');
		} else {
			prop.closest('.sub-nav').addClass('r-shadow');
		}

		// console.log(prop.scrollLeft());

	}

	/* on click listener for scrolling sub-nav ul left and right */
	$(document).on('click', '.j-scroll-btn', function (e) {
		e.preventDefault();
		if ($(this).hasClass('left')) {
			$(this).closest('.sub-nav-links').find('ul')[0].scrollLeft -= 200;
		} else {
			$(this).closest('.sub-nav-links').find('ul')[0].scrollLeft += 200;
		}
	});

	/* scrolls subnav on mobile to the appropriate link*/
	if ($('.sub-nav').length) {

		$('.sub-nav ul').on('scroll', function (e) {
			applyShadow($('.sub-nav ul'));
		});

		applyShadow($('.sub-nav ul'));

		var activeElement_offsetLeft = 0;
		var activeElement_offsetWidth = 0;

		if ($('.sub-nav ul .active').length) {
			activeElement_offsetLeft = $('.sub-nav ul .active')[0].offsetLeft;
			activeElement_offsetWidth = $('.sub-nav ul .active')[0].offsetWidth;
		}

		var containerScrollWidth = $('.sub-nav ul')[0].scrollWidth;
		var containerVisibleWidth = $('.sub-nav ul').innerWidth();


		// console.log("Active ele offset Left: "+activeElement_offsetLeft,"Active ele offset Width: "+activeElement_offsetLeft,"Container Scroll Width: "+containerScrollWidth,"Container Visible Width: "+containerVisibleWidth);

		/*
			Check to see if there is overflow in the subnav but for desktop
		*/
		if (containerVisibleWidth < containerScrollWidth) {
			$('.sub-nav').addClass('has-overflow');
		}


		/* 
			if an elements offsetWidth + its offsetLeft is greater than the width of the visable container
			then we know an offset has occured.

			so we scroll to the start of that offsetLeft , minus its offsetWidth.
		 */
		if ((activeElement_offsetLeft + activeElement_offsetWidth) > containerVisibleWidth) {
			$('.sub-nav ul').animate({
				scrollLeft: activeElement_offsetLeft - activeElement_offsetWidth
			}, 600);
		}


	}
	/* end */

	// IE11 detection

	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	var IE11Warning = '<div class="browser-warning"><p>We only offer partial support for this browser. To get the best experience we recommend downloading <a href="https://www.google.com/intl/en/chrome/" target="_blank"><u>Google Chrome</u></a>.</p><span class="close-icon j-close-browser-warning"></span></div>';

	if (isIE11 == true) {

		body.append(IE11Warning);

		$(document).on('click', '.j-close-browser-warning', function (e) {

			$('.browser-warning').fadeOut();

		});

	}

	if ($('.hero-carousel').length) {
		$('.j-hero-carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			fade: true,
			autoplay: true,
			speed: 900,
			autoplaySpeed: 3000,
			swipeToSlide: true,
			infinite: true
		});
	}

	// if( $('.featured-collection-listing .collection-filters').length ) {
	// 	$('.j-col-filters-carousel').slick({
	// 		slidesToShow: 8,
	// 		slidesToScroll: 1,
	// 		arrows: false,
	// 		dots: false,
	// 		autoplay: false,
	// 		speed: 900,
	// 		swipeToSlide: true,
	// 		infinite: true,
	// 		responsive: [
	// 			{
	// 				breakpoint: 1024,
	// 				settings: {
	// 					slidesToShow: 1,
	// 					slidesToScroll: 1,
	// 					variableWidth: true,
	// 					centerMode: false,
	// 					arrows: false,
	// 					centerPadding: "0px"
	// 				}
	// 			}
	// 		]			
	// 	});	

	// if( $('.featured-collection-listing .collection-panels').length ) {
	// 	$('.j-col-panels-carousel').slick({
	// 		slidesToShow: 1,
	// 		slidesToScroll: 1,
	// 		arrows: false,
	// 		dots: false,
	// 		fade: true,
	// 		autoplay: false,
	// 		speed: 900,
	// 		swipeToSlide: true,
	// 		infinite: true
	// 	});	
	// }		

	
	if ($(".product-image-wrap").length) {

		function setupProductCarousel() {
			$('.j-product-img-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				fade: true,
				centerMode: true,
				centerPadding: '0px',
				speed: 700,
				dots: true,
				arrows: false
			});
		}

		setupProductCarousel();

		function addVariantImages(goToSlide) {

			// Get variant ID from the Vue product options data attribute
			const selectedVariantIdField = document.querySelector("[data-selected-variant-id]");
			const variantId = selectedVariantIdField?.value;
			
			if (!variantId) return;
			

			const images = Array.from(document.querySelectorAll(`[data-product-carousel-hidden-images] [data-metafield-variant-image][data-metafield-variant="${variantId}"]`));
			const isCarouselEmpty = !$('.j-product-img-carousel').slick('getSlick').$slides.length;


			if (isCarouselEmpty) {
				images.forEach(image => {
					// unslick the carousel
					$('.j-product-img-carousel').slick('unslick');
					$('.j-product-img-carousel').append($(image).clone());
					setupProductCarousel();
				});
			} else {
				images.reverse().forEach(image => {
					$('.j-product-img-carousel').slick("slickAdd", $(image).clone(), 0, true);
				});
			}
		}

		const productOptionsElement = document.querySelector('.vue-product-options');

		productOptionsElement.addEventListener('vue3-product-options-loaded', (event) => {
			console.log('Product loaded:', event.detail.product);
			const productId = event.detail.product.id;
			const getSelectedVariantId = () => productOptionsElement.querySelector("[data-selected-variant-id]")?.value;

			setTimeout(function(){

				// filter hidden images

				addVariantImages();
				updateVariantDynamicContent(productId, getSelectedVariantId());
				updatePdpFlagSticker(productId, getSelectedVariantId());
				$('.j-product-img-carousel').slick('slickFilter', function(index, slide){
					return !slide.classList.contains('hidden');
				});

				// Listen for changes on vue-product-options
				productOptionsElement.addEventListener('change', function(e){
					if (!$("[data-product-carousel-hidden-images] [data-metafield-variant-image]").length) return;
					
					// Use consistent selector with setupProductCarousel
					$('.j-product-img-carousel').slick('unslick');
					
					// Remove variant-specific slides
					$('.j-product-img-carousel [data-metafield-variant]').remove();
					
					setTimeout(function(){
						setupProductCarousel();
						// Get the updated variant ID from data-selected-variant-id
						console.log('variant change', getSelectedVariantId());
						addVariantImages(true);
						updateVariantDynamicContent(productId, getSelectedVariantId());
						updatePdpFlagSticker(productId, getSelectedVariantId());
					});
				})
			})
		});
		
		function updateVariantDynamicContent(productId, variantId) {
			const reviewsPanel = document.querySelector(`[data-customer-reviews-panel="${productId}"]`);
			const productTemplate = document.querySelector(`[data-product-template="${productId}"]`);

			console.log('reviewsPanel', reviewsPanel);
			console.log('productTemplate', productTemplate);

			const dynamicContentElements = document.querySelectorAll(`[data-customer-reviews-panel="${productId}"] [data-variant-dynamic-content], [data-product-template="${productId}"] [data-variant-dynamic-content]`);
			console.log('dynamicContentElements', dynamicContentElements);
			dynamicContentElements.forEach(element => {
				element.classList.toggle("show", element.dataset.variantDynamicContent === variantId);
			});
		}

		function updatePdpFlagSticker(productId, variantId) {
			console.log('updatePdpFlagSticker', productId, variantId);
			try {
				const productTemplate = document.querySelector(`[data-product-template="${productId}"]`);
				const flagStickers = productTemplate.querySelectorAll('[data-pdp-flag-sticker-variant-ids]');
				Array.from(flagStickers).forEach(flagSticker => {
					const variantIds = flagSticker.dataset.pdpFlagStickerVariantIds.split(',');

					if (variantIds.includes(variantId)) {
						flagSticker.classList.remove('hidden');
					} else {
						flagSticker.classList.add('hidden');
					}
				});

			} catch (error) {
				console.error('Error updating PDP flag sticker:', error);
			}
		}
		
	}

	if ($('.featured-carousel').length) {
		$('.j-featured-product-carousel').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			swipeToSlide: true,
			infinite: true,
			centerMode: true,
			centerPadding: '60px',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: true,
						centerMode: true,
						arrows: false,
						dots: false,
						swipeToSlide: true,
						infinite: true,
						centerPadding: '80px'
						// centerPadding: "0px"
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						dots: false,
						swipeToSlide: true,
						infinite: true,
						centerMode: true,
						variableWidth: true,
						centerPadding: '110px'
					}
				},
			]

		});
	}

	if ($('.related-carousel').length) {
		$('.j-related-carousel').slick({
			slidesToShow: 3,
			slidesToScroll: 1,

			swipeToSlide: true,
			// infinite: true,
			// centerMode: true,
			// centerPadding: '0px',

			dots: false,
			arrows: false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						centerMode: true,
						slidesToShow: 1,
						centerPadding: '0px',
						infinite: true,
						swipeToSlide: true,
						variableWidth: true,
						autoplay: true,
						speed: 700,
						autoplaySpeed: 2000
					}
				}
			]
		});
	}

	if ($('.featured-collection-listing').length) {
		$('.j-col-panels-carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			dots: false,
			fade: true,
			arrows: true,
			prevArrow: $('.prev-btn'),
			nextArrow: $('.overlay-button.next'),
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						centerMode: true,
						slidesToShow: 1,
						fade: false,
						centerPadding: '0px',
						infinite: true,
						swipeToSlide: true,
						variableWidth: false,
						autoplay: false,
						speed: 700,
						autoplaySpeed: 2000
					}
				}
			]
		});
	}

	/* Site header clickable dropdown */
	if ($(window).width() > 1023) {
		$(document).on('click', '.site-header .clickable-dropdown .j-toggle-search', function (e) {
			e.preventDefault();
			$('.clicked-dropdown-modal-overlay').toggleClass('active');

			$(this).toggleClass('active');
			$(this).parent().toggleClass('clicked-active');

			// if the link has an active class (after we toggled it above)
			// then that means it was just opened, so focus the search input field
			if ($(this).hasClass('active')) {
				$(this).parent().find('.dropdown .search-bar-wrap .searchForm input#search').focus();
			}
		});

		$(document).on('click', '.j-close-clicked-dropdown', function (e) {
			e.preventDefault();
			$('.site-header .clickable-dropdown .j-toggle-search').removeClass('active');
			$('.clicked-dropdown-modal-overlay').removeClass('active');
			$('.site-header .clickable-dropdown').removeClass('clicked-active');

		});
	}
	/* End */

	/* Animation class application to explore-grid panel opn mobile */

	function restartPulseAnimation() {
		$('.explore-grid-listing .explore-grid').removeClass('animate');
		// setTimeout(() => { $('.explore-grid-listing .explore-grid').addClass('animate'); }, 500);
		setTimeout(function () { $('.explore-grid-listing .explore-grid').addClass('animate'); }, 500);
	}

	if ($('.explore-grid-listing').length) {
		if ($(window).width() < 1024) {
			// setTimeout(restartPulseAnimation,5000);

			let timerId = setInterval(restartPulseAnimation, 18000);
			// setTimeout(() => { clearInterval(timerId); }, 48000);	
		}
	}

	// Toggle order click on acount page

	$(document).on('click', '.j-toggle-order', function () {

		$(this).parent().next().slideToggle();

	});

	//Smooth scroll for secondary nav

	$(document).on('click', '.j-link', function (e) {
		var dataScroll = $(this).data('scroll');
		$(this).addClass('active').parent().siblings().children().removeClass('active');
		console.log($('#' + dataScroll))

		$('html,body').animate({
			scrollTop: $('#' + dataScroll).offset().top - 260
		});
	});

	//Smooth scroll for any link

	$(document).on('click', 'a:not(.j-link)', function (e) {
		if (e.target.hash?.length) {
			$('html, body').animate({
				scrollTop: $(e.target.hash).offset().top - 260
			}, 1000);
		}
	})

	//Smooth scroll on document load

	function scrollOnPageLoad() {
		// to top right away
		if (window.location.hash) scroll(0, 0);
		// void some browsers issue
		setTimeout(scroll(0, 0), 1);
		let hashLink = window.location.hash;
		if ($(hashLink).length) {
			$(function () {	// *only* if we have anchor on the url
				$('html, body').animate({
					scrollTop: $(window.location.hash).offset().top - 260
				}, 1000);
			});
		}
	}

	scrollOnPageLoad();

	// Show new address form

	$(document).on('click', '.j-add-new-address', function (e) {

		e.preventDefault();
		$('.account-template-wrapper .address-forms form').hide();
		$('.account-template-wrapper .address-forms #address_form_new').show();


	});

	$(document).on('click', '.j-cancel-new-address', function (e) {

		e.preventDefault();
		$('#address_form_new').hide();


	});

	$(document).on('click', '.j-repurchase-order', function (e) {

		e.preventDefault();

		var btn = $(this);

		var text = $(this).text();
		btn.text('Adding products to cart...');

		$(this).parent().siblings().addClass('reached');

		$(this).parent().siblings().each(function () {

			var reorder_variant_id = $(this).data('reorder_variant_id');
			var reorder_quantity = $(this).data('reorder_quantity');

			var properties = {};

			CartJS.addItem(reorder_variant_id, reorder_quantity, properties, {
				"success": function (data, textStatus, jqXHR) {
					console.log('Added product');
				},
				"error": function (jqXHR, textStatus, errorThrown) {
					console.log('Error: ' + errorThrown + '!');
				}
			});

		});

		setTimeout(function () {

			btn.text('Items are in your bag');

		}, 3000);

		setTimeout(function () {

			btn.text(text);

		}, 6000);

	});

	// Add marquee to announcement bar on mobile

	if ($(window).width() < tablet_breakpoint) {

		if ($('.announcement-bar').length > 0) {

			$('.announcement-bar .inner').addClass('marquee');

		}

	}

	/* == Homepage Stockists ============================================= */

	$('.j-stockist-carousel').slick({
		infinite: true,
		autoplay: true,
		variableWidth: true,
		centerMode: true,
		arrows: false,
		dots: true,
		swipeToSlide: true
	});

	$('.slick-slider').show(); // Show all carousels once page loaded - must be after all slick calls

	$(".text-grid-image-panel .desc strong").each(function () {
		if ($(this).text().trim() !== "*") return;
		$(this).addClass("hidden");
		$(this).parent().addClass("user-list-item");
	})



	// READ MORE logic
	// READ MORE logic
	document.querySelectorAll("[data-read-more]").forEach(shortDesc => {
		const fullDesc = shortDesc.nextElementSibling;
		const wordCount = parseInt(shortDesc.dataset.wordCount, 0);
		const maxWordCount = parseInt(shortDesc.dataset.maxWordCount, 0);

		if (wordCount <= maxWordCount) {
			return;
		}

		fullDesc.classList.add("hidden");
		shortDesc.classList.remove("hidden");

		const toggleDescription = () => {
			fullDesc.classList.toggle("hidden");
			shortDesc.classList.toggle("hidden");
		};

		const shortDescButton = shortDesc.querySelector('[data-read-more-btn]');
		const fullDescButton = fullDesc.querySelector('[data-read-more-btn]');

		shortDescButton.addEventListener("click", toggleDescription);
		fullDescButton.addEventListener("click", toggleDescription);
	});

});

$(document).on('click', '.tab-1', function (e) {
	$(this).parent().find('a.is-active').removeClass('is-active');
	$(this).addClass('is-active');
	console.log("clicked tab 1");
	$('.tab-content-1').show();
	$('.tab-content-2').hide();
	$('.tab-content-3').hide();
	$('.tab-content-4').hide();
	$('.tab-content-5').hide();
});
$(document).on('click', '.tab-2', function (e) {
	$(this).parent().find('a.is-active').removeClass('is-active');
	$(this).addClass('is-active');
	$('.tab-content-1').hide();
	$('.tab-content-2').show();
	$('.tab-content-3').hide();
	$('.tab-content-4').hide();
	$('.tab-content-5').hide();
});
$(document).on('click', '.tab-3', function (e) {
	$(this).parent().find('a.is-active').removeClass('is-active');
	$(this).addClass('is-active');
	$('.tab-content-1').hide();
	$('.tab-content-2').hide();
	$('.tab-content-3').show();
	$('.tab-content-4').hide();
	$('.tab-content-5').hide();
});
$(document).on('click', '.tab-4', function (e) {
	$(this).parent().find('a.is-active').removeClass('is-active');
	$(this).addClass('is-active');
	$('.tab-content-1').hide();
	$('.tab-content-2').hide();
	$('.tab-content-3').hide();
	$('.tab-content-4').show();
	$('.tab-content-5').hide();
});
$(document).on('click', '.tab-5', function (e) {
	$(this).parent().find('a.is-active').removeClass('is-active');
	$(this).addClass('is-active');
	$('.tab-content-1').hide();
	$('.tab-content-2').hide();
	$('.tab-content-3').hide();
	$('.tab-content-4').hide();
	$('.tab-content-5').show();
});

$(document).on('click', '.mobile-tab-1', function (e) {

	$('.tab-content-1').toggle("fast");
	$('.tab-content-2').hide();
	$('.tab-content-3').hide();
	$('.tab-content-4').hide();
	$('.tab-content-5').hide();
});
$(document).on('click', '.mobile-tab-2', function (e) {

	$('.tab-content-1').hide();
	$('.tab-content-2').toggle("fast");
	$('.tab-content-3').hide();
	$('.tab-content-4').hide();
	$('.tab-content-5').hide();
});
$(document).on('click', '.mobile-tab-3', function (e) {

	$('.tab-content-1').hide();
	$('.tab-content-2').hide();
	$('.tab-content-3').toggle("fast");
	$('.tab-content-4').hide();
	$('.tab-content-5').hide();
});
$(document).on('click', '.mobile-tab-4', function (e) {

	$('.tab-content-1').hide();
	$('.tab-content-2').hide();
	$('.tab-content-3').hide();
	$('.tab-content-4').toggle("fast");
	$('.tab-content-5').hide();
});
$(document).on('click', '.mobile-tab-5', function (e) {

	$('.tab-content-1').hide();
	$('.tab-content-2').hide();
	$('.tab-content-3').hide();
	$('.tab-content-4').hide();
	$('.tab-content-5').toggle("fast");
});




